import { StrictMode } from 'react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Initialize Sentry BEFORE React (must be first!)
import { initSentry } from './utils/sentry'
initSentry()

// Initialize i18n BEFORE React renders
import './i18n'

// Accessibility Testing (Development Only)
if (import.meta.env.DEV) {
  import('@axe-core/react').then((axe) => {
    axe.default(React, ReactDOM, 1000, {
      // WCAG 2.1 Level AA Rules
      runOnly: ['wcag2a', 'wcag2aa', 'wcag21a', 'wcag21aa', 'best-practice'],
    });
  }).catch(() => {
    // Silently fail if axe-core not available
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
